import React, {useEffect, useState} from 'react';
import { NavLink } from "react-router-dom";
import SarasMakeStyles from '../../../library/decor/makeStyles/SarasMakeStyles'
import SarasCssBaseline from '../../../library/decor/cssBaseline/SarasCssBaseline.js';
import SarasDrawer from '../../../library/container/drawer/SarasDrawer';
import SarasList from '../../../library/repeater/list/SarasList';
import SarasListItem from '../../../library/repeater/list/SarasListItem';
import SarasDrawerMenuItem from './SarasDrawerMenuItem';
import {HomeIcon} from '../../../library/decor/SarasIcons';
import useSarasStore from '../../../library/hooks/localDB/useSarasStore'
import AppMenu from '../../../layout/main/components/AppMenu.js';

const SarasDrawerMenu = (props) => {
  const classes = UseStyles();
  const localDb = useSarasStore();

  const [appMenus, setAppMenus] = useState([]);
  const [anchorRef, setAnchorRef] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [targetMenuRow, setTargetMenuRow] = useState(null);

  const checkIfMenuRequired = () => {
    if(!appMenus || appMenus.length === 0)
    {
        localDb.getAppMenu(onLocalMenuSuccess);
    }
  };

  useEffect(checkIfMenuRequired, [appMenus]);

  const onLocalMenuSuccess = (key, value) =>  {
    //this is required since in previous version menu was 
    //stored as a string and user will face issue in first login
    if(value && typeof value != "string"){
      setAppMenus(value);
    }
}

  const handleAppMenuClick = (menuRow, itemRef) => {
    setAnchorRef(itemRef);
    setIsMenuOpen(true);
    setTargetMenuRow(menuRow);
  }

  const handleAppMenuClose = () => {
    setIsMenuOpen(false);
  };

  if(!appMenus) {
    return (
      null
    )
  }

  return (
    <div className='uiAppDrawerMenu'>
      <div className={classes.root}>
        <SarasCssBaseline/>
        <SarasDrawer
          className={classes.drawer}
          variant="permanent"
          anchor="left"
          open={props.isMenuOpen || true}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <SarasList component="nav" disablePadding style={{marginTop:'35px',marginBottom: '35px', width: '100%'}} >
            <NavLink to="/home" key="saras-home">
              <SarasListItem ListIcon={HomeIcon} iconClass='uiAppIcon saras-tour-home-side-menu-home'>
              </SarasListItem>
            </NavLink>
            {appMenus.map((menu, index) => (
              menu.MenuType !== 's' ? <SarasDrawerMenuItem menuRow={menu} key={index} onClick={handleAppMenuClick}/>
              : null
            ))}
          </SarasList>
        </SarasDrawer>
      </div>
      <AppMenu anchorRef={anchorRef} isMenuOpen={isMenuOpen} placement="right" 
        onClose={handleAppMenuClose} 
        scrollToMenuRow={targetMenuRow}
      />
    </div>
  );
}

const DRAWER_WIDTH = 50;

const UseStyles = SarasMakeStyles(theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    width: DRAWER_WIDTH,
    flexShrink: 0,
  },
  drawerPaper: {
    width: DRAWER_WIDTH,
    backgroundColor: '#000', // Set drawer background to black
    color: '#fff',    
    paddingTop: 0,
    paddingBottom: '0px',
    boxSizing: 'border-box', // Ensure padding is handled as expected
  },
}));

export default SarasDrawerMenu;
